// extracted by css-extract-rspack-plugin
var _1 = "L7y5m";
export { _1 as "singleLineContent" }
